import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: "#F5F5F5",
    borderRadius: "10px",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    // minHeight: "100vh",
    alignItems: "center",
    backgroundColor: "#EDF2F7",
    padding: theme.spacing(2),
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    height: "100%",
    width: "100%",
    padding: theme.spacing(4),
    gap: "8px",
    margin: 0,
    boxShadow: "none",
    borderRadius: 0,
    backgroundColor: "#FFF",
    [theme.breakpoints.down("sm")]: {
      marginTop:"30px"
    }},
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  loginTitle: {},

  titleCon: {
    paddingTop: 0,
    fontFamily: "MontserratRegular",
    fontWeight: 700,
    fontSize: "18px",
    Lineheight: "23.03px",
    textTransform:'capitalize'
  },

  title: {
    fontSize: "2.75rem",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },

  paragraphText: {
    display: "block",
    color: "#706C7C",
    fontWeight: 200,
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
    margin: `${theme.spacing(1)}px 0`,
  },
  dividerLine: {
    flexGrow: 1,
    height: "1px",
    backgroundColor: theme.palette.divider,
  },
  dividerText: {
    margin: `0 ${theme.spacing(1)}px`,
    color: "#706C7C",
    fontWeight: 600,
    fontSize: 18,
  },
  logoWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItem: "center",
    "& img":{
      width:'180px',
      [theme.breakpoints.down("md")]: {
        width: "140px", 
      },
  
      [theme.breakpoints.down("sm")]: {
        width: "120px", 
      },
  
      [theme.breakpoints.down("xs")]: {
        width: "100px", 
      },

    }
  },
  formLabel: {
    color: "#2158D0",
    display: "block",
    textAlign: "left",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28.79px",
    fontFamily: "MontserratRegular",
    marginTop: "0px",
  },
  messageIconWrapper: {
    display: "flex",
    gap: "10px",
    left: "0px",
  },
  postHeading: {
    display: "flex",
    justifyContent: "center",
    alignItem: "cener",
    flexDirection: "column",
    gap: "0px",
  },
  postHeadingText: {
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28.79px",
    fontFamily: "MontserratRegular",
  },

  bannerWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    marginTop:'50px'
    // marginTop: theme.spacing(2),
  },

  bannerImage: {
    width: "100%", // Full width
    height: "auto",
    objectFit: "cover",
  },

  imageCredit: {
    fontSize: "12px",
    color: "#777",
    marginTop: theme.spacing(1),
    fontStyle: "italic",
  },
  titletext:{
    fontWeight: 700,
    fontFamily: 'MontserratRegular',
    fontSize: '20px',
    color: "#2158D0",
    textTransform:"capitalize"
  },
  listItemText: {
    fontFamily: "Nunito Sans",
    fontSize: '14px',
    marginLeft: theme.spacing(1),
    '&.active': {
        backgroundColor: '#232222',
        color: '#ffffff',
    },
    "& .MuiListItemText-primary": {
        color: "#2158D0",
        fontFamily: "MontserratRegular",
        fontWeight: "700",
        Size: "16px",
        LineHeight: '20.15px'
    },
},
recentPostsContainer: {
  padding: '16px',
  backgroundColor: '#FFF',
  borderRadius: '8px',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
},
postItem:{
  display: 'flex',
  alignItems: 'center',
  borderBottom: '1px solid #ddd',
  padding: '8px 0',
  cursor:'pointer'
},
postImage:{
  width: '40px',
  height: '40px',
  borderRadius: '50%',
},
postItemText:{
  fontFamily: "Nunito Sans",
  "& .MuiListItemText-primary": {
      color: "black",
      fontFamily: "MontserratRegular",
      fontWeight: "700",
      Size: "20px",
      LineHeight: '20.15px'
  },
},
postContent: {
  "& img": {
    maxWidth: "100%", // Ensures images don't overflow
    height: "auto",
    display: "block",
    margin: "0 auto", // Centers the image
  },
  "& .generated-summary":{
    textAlign:'justify'
  }
},

viewMorebtn:{
  backgroundColor: "#1A73E8",
          color: "#FFF",
          borderRadius: "8px",
          padding: "6px 16px",
          fontSize: "14px",
          fontWeight: "bold",
          textTransform: "none",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          width:"150px",
          justifyContent: "space-evenly",
          "&:hover": { backgroundColor: "#1669C1" },
        
},
verticalDivider: {
  height: '70%', 
  width: '1px',
  backgroundColor: 'rgba(0, 0, 0, 0.2)', 
  marginLeft: '10px',
  marginRight: '10px',
},
divider: {
  width: "2px",
  height: "40px",
  backgroundColor: "#00000033",
  margin: "0 10px",
},
timeText: {
color: "#2158D0",
fontFamily: "Nunito Sans",

},
//create Post 
header: {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing(4),
},

form: {
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(5),
  margin: "auto",
  minWidth: 400,
},
backIcon: {
  width: 32,
  height: 32,
  cursor: "pointer",
},
logo: {
  width: 48,
  height: 48,
},
mainTitle: {
  fontWeight: 700,
  color: "#000000",
  marginBottom: theme.spacing(3),
  textTransform: "capitalize",
},
inputStyle: {
  border: 0,
  backgroundColor: "white",
  color: "#F5F5F5",
},
submitBtn: {
  background: "#5C91FF",
  color: "#FFFFFF",
  textTransform: "capitalize",
  marginRight: "20px",
  borderRadius: 6,
  padding: "11px 11px",
  width: "calc(100% - 120px)",
  marginBottom: theme.spacing(2),
  "&:hover": {
    background: "#5C91FF",
  },
  "& .MuiButton-fullWidth": {
    width: "calc(100% - 120px)",
  },
  fontWeight: 700,
  fontSize: "20px",
},
}));